// Journey dots, exactly as prototype G: 4 stages, imported · sent · delivered · read.
import type { PStatus } from "./status";

export const JOURNEY_STEPS = ["Imported", "Sent", "Delivered", "Read"] as const;

/** Class per dot: "on" | "read" | "bad" | "warn" | "mute" | "pulse", space-joined; "" = off. */
export function journey(s: PStatus): [string, string, string, string] {
  switch (s) {
    case "queued":
      return ["on", "", "", ""];
    case "sending":
      return ["warn pulse", "", "", ""];
    case "sent":
      return ["on", "on", "", ""];
    case "delivered":
      return ["on", "on", "on", ""];
    case "read":
      return ["on", "on", "on", "on read"];
    case "retrying":
    case "over_limit":
      return ["on", "warn", "", ""];
    case "opted_out":
      return ["on", "on", "on", "mute"];
    case "failed":
    case "invalid":
      return ["bad", "", "", ""];
    case "not_on_list":
      return ["", "", "", ""];
  }
}

/** Legend lines for the hover tooltip. */
export function journeyLegend(s: PStatus): { label: string; cls: string }[] {
  const d = journey(s);
  return JOURNEY_STEPS.map((name, i) => {
    const cls = d[i]!.replace("pulse", "").trim();
    let suffix = "";
    if (i === 0 && s === "sending") suffix = " · sending now";
    if (cls.includes("bad")) suffix = " · stopped here";
    else if (cls.includes("warn") && s === "retrying") suffix = " · stuck, retrying";
    else if (cls.includes("warn") && s === "over_limit") suffix = " · over the 24h limit";
    else if (cls.includes("mute")) suffix = " · they opted out";
    return { label: name + suffix, cls };
  });
}
